import { ModalConfirmation, ModalProps, withModalConditionalRender } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

interface MarkAsCompletedConfirmationModalProps extends ModalProps {
  isProcessing?: boolean
  onOk?: () => void
}

const MarkAsCompletedConfirmationModalComponent = ({
  id,
  isProcessing,
  onOk,
}: MarkAsCompletedConfirmationModalProps) => {
  const { t } = useTranslation()

  const handleModalOkClick = useCallback(() => {
    onOk?.()
  }, [onOk])

  return (
    <ModalConfirmation
      cancelLabel={t('recurring_invoices.mark_as_completed.modal.button.cancel.label')}
      id={id}
      message={t('recurring_invoices.mark_as_completed.modal.message')}
      okLabel={t('recurring_invoices.mark_as_completed.modal.button.ok.label')}
      okLoading={isProcessing}
      onOk={handleModalOkClick}
      title={t('recurring_invoices.mark_as_completed.modal.title')}
    />
  )
}

export const MarkAsCompletedConfirmationModal = withModalConditionalRender(MarkAsCompletedConfirmationModalComponent)
